import { cn } from "@postdaily/ui/lib/utils";
import { Link } from "@tanstack/react-router";

/**
 * Shared marketing lockup using the official brand mark plus the
 * PostDaily wordmark.
 */
export function MarketingLogo({ className }: { className?: string }) {
  return (
    <Link
      to="/"
      className={cn(
        "inline-flex shrink-0 items-center gap-2.5 no-underline",
        className,
      )}
    >
      <img
        src="/logo-64.webp"
        // A 31px slot: 64w covers it to DPR 2, 128w beyond. Width descriptors
        // rather than 1x/2x so `sizes` is honoured and a 2x phone does not pull
        // the larger file for a mark that renders at 31 CSS px.
        srcSet="/logo-64.webp 64w, /logo-128.webp 128w"
        sizes="31px"
        alt="PostDaily logo"
        className="size-[31px] shrink-0"
        width={31}
        height={31}
      />
      <span className="font-heading text-[23px] text-foreground leading-none tracking-[0.2px]">
        PostDaily
      </span>
    </Link>
  );
}
